"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icons = void 0;
var Icons;
(function (Icons) {
    Icons["ACCIDENT"] = "person-injured";
    Icons["ADVICE"] = "umbrella-heart";
    Icons["ANIMAL"] = "dog-cat";
    Icons["BIKE"] = "bicycle";
    Icons["BOAT"] = "sailboat";
    Icons["CABIN"] = "cabin-1";
    Icons["CABIN_CONTENT"] = "cabin-furniture";
    Icons["CAMERA"] = "camera";
    Icons["CAPITAL"] = "money-stack-1";
    Icons["CAR"] = "car";
    Icons["CARAVAN"] = "caravan";
    Icons["CHILD"] = "teddy-bear";
    Icons["COMPUTER_EQUIPMENT"] = "laptop-checkbox";
    Icons["CRITICAL_ILLNESS"] = "medical-bag";
    Icons["DEATH"] = "dove";
    Icons["DEBT"] = "umbrella";
    Icons["DISABILITY"] = "hand-coins-umbrella";
    Icons["ELECTRIC_SCOOTER"] = "electric-scooter";
    Icons["EL_BIKE"] = "electric-bike";
    Icons["EMPLOYEE"] = "personal-details-card";
    Icons["FIREARM"] = "weapon";
    Icons["FUR_COAT"] = "fur-coat";
    Icons["GOLF_EQUIPEMENT"] = "golf";
    Icons["HANDSHAKE"] = "handshake";
    Icons["HEALTH"] = "stethoscope";
    Icons["HEARING_AID"] = "hearing-aid";
    Icons["HOUSE"] = "house";
    Icons["HOUSE_CONTENT"] = "home-furniture";
    Icons["HOME_NEW"] = "home-new";
    Icons["HAND_COINS"] = "hand-coins";
    Icons["LIFE"] = "man-heart";
    Icons["MOPED"] = "moped";
    Icons["MOTORCYCLE"] = "motorcycle";
    Icons["NATIONAL_COSTUME"] = "bunad";
    Icons["OTHER"] = "other-items";
    Icons["PENSION"] = "hand-coin";
    Icons["PREGNANT_AND_NEWBORN"] = "pacifier";
    Icons["TRACTOR"] = "tractor";
    Icons["TRAILER"] = "trailer";
    Icons["TRAVEL"] = "suitcase-palm-tree";
    Icons["TRUCK"] = "truck";
    Icons["VALUABLES"] = "diamond-ring";
    Icons["VETERAN"] = "car-veteran";
})(Icons = exports.Icons || (exports.Icons = {}));
//# sourceMappingURL=icons.js.map